import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  DaterangepickerModule,
  AutocompleteModule,
  ComboModule,
  InputModule,
  SharedModule,
} from 'beyond-util';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';
import { IzvestajZaPgpIMuzickuProdukcijuComponent } from './izvestaj-za-pgp-i-muzicku-produkciju.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    SharedModule,
    NgxSpinnerModule,
  ],
  declarations: [IzvestajZaPgpIMuzickuProdukcijuComponent],
  exports: [IzvestajZaPgpIMuzickuProdukcijuComponent],
  entryComponents: [IzvestajZaPgpIMuzickuProdukcijuComponent],
})
export class IzvestajZaPgpIMuzickuProdukcijuModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-pgp-i-muzicku-produkciju/izvestaj-za-pgp-i-muzicku-produkciju.module.ts